import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from 'components/form/FormLabel';
import PropTypes from 'prop-types';
import React from 'react';

const CustomRadioGroup = React.forwardRef(
  (
    {
      label = '',
      value,
      onChange,
      name,
      options,
      hasError,
      helpText,
      labelKey = 'label',
      valueKey = 'value',
      row,
      size,
      fullWidth,
      disabled,
      renderChildren,
      sx,
      margin = 'dense',
    },
    ref,
  ) => (
    <FormControl
      component="fieldset"
      margin={margin}
      error={hasError}
      fullWidth={fullWidth}
      disabled={disabled}
      sx={sx}
    >
      {label && <FormLabel sx={{ pl: 0 }}>{label}</FormLabel>}
      <RadioGroup
        row={row}
        name={name}
        value={value}
        onChange={onChange}
        color="primary"
        ref={ref}
      >
        {options.map((i) => (
          <>
            <FormControlLabel
              componentsProps={{
                typography: {
                  variant: size === 'small' ? 'body2' : 'body1',
                },
              }}
              key={i[valueKey]}
              value={i[valueKey]}
              control={<Radio size={size} />}
              label={i[labelKey]}
            />
            {renderChildren && value === i[valueKey] && renderChildren(i)}
          </>
        ))}
      </RadioGroup>
      {hasError && <FormHelperText sx={{ m: 0 }}>{helpText}</FormHelperText>}
    </FormControl>
  ),
);

CustomRadioGroup.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  row: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CustomRadioGroup;
